import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";

import { useAIAgentThread } from "@/AgentThread/AgentThreadSidebar/AIAgentThreadContext";
import { RobotoIconButton } from "@/shared/components/RobotoIconButton";
import { RobotoTooltip } from "@/shared/components/RobotoTooltip";

import styles from "./AgentThreadSidebarControls.module.css";
import { EarlyAccessInfoPopover } from "./EarlyAccessInfoPopover.tsx";

interface AgentThreadSidebarControlsProps {
  onClose: () => void;
}

export const AgentThreadSidebarControls = ({
  onClose,
}: AgentThreadSidebarControlsProps) => {
  const {
    isFullscreen,
    handleNewThread,
    handleToggleFullscreen,
    handleToggleHistory,
    showHistory,
  } = useAIAgentThread();

  return (
    <header className={styles.header}>
      <div className={styles.titleContainer}>
        <EarlyAccessInfoPopover />
      </div>
      <div className={styles.navItems}>
        <RobotoTooltip
          title={showHistory ? "Hide My Threads" : "Show My Threads"}
        >
          <span>
            <RobotoIconButton
              onClick={handleToggleHistory}
              eventName={"AgentThreadHistoryToggled"}
              size="small"
            >
              {showHistory ? (
                <LibraryBooksIcon className={styles.activeIconButton} />
              ) : (
                <LibraryBooksIcon className={styles.iconButton} />
              )}
            </RobotoIconButton>
          </span>
        </RobotoTooltip>
        <RobotoTooltip title={"New Thread"}>
          <span>
            <RobotoIconButton
              onClick={handleNewThread}
              eventName={"NewAgentThreadClicked"}
              size="small"
            >
              <AddIcon className={styles.iconButton} />
            </RobotoIconButton>
          </span>
        </RobotoTooltip>
        <RobotoTooltip title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}>
          <span>
            <RobotoIconButton
              onClick={handleToggleFullscreen}
              eventName={"AgentThreadFullscreenToggled"}
              size="small"
            >
              {isFullscreen ? (
                <FullscreenExitIcon className={styles.iconButton} />
              ) : (
                <FullscreenIcon className={styles.iconButton} />
              )}
            </RobotoIconButton>
          </span>
        </RobotoTooltip>
        <RobotoTooltip title={"Close"}>
          <span>
            <RobotoIconButton
              onClick={onClose}
              eventName={"CloseAgentThreadWindowClose"}
              size="small"
            >
              <CloseIcon className={styles.iconButton} />
            </RobotoIconButton>
          </span>
        </RobotoTooltip>
      </div>
    </header>
  );
};
